import type { ReactNode } from "react";

import { useRequiredContext } from "@lib/utils";

import { HaNDetailsContext } from "../shell/regions/HaNDetailsContext";
import { HaNDetailsHeader } from "./HaNDetailsHeader";

type HaNDetailsPageProps = {
  title: string;
  onBack?: () => void;
  footer?: ReactNode;
  children: ReactNode;
};

/**
 * One page of the details: the header, the content scrolling under it, and an optional footer at the bottom. Close
 * asks first when it would throw away a booking with changes.
 */
export const HaNDetailsPage = ({ title, onBack, footer, children }: HaNDetailsPageProps) => {
  const { close } = useRequiredContext(HaNDetailsContext);

  return (
    <>
      <HaNDetailsHeader
        title={title}
        onBack={onBack}
        onClose={close}
      />

      <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>

      {footer && <div className="flex-none border-t px-5 py-4">{footer}</div>}
    </>
  );
};
